import { z } from 'zod';

export const UNIT_SUGGESTIONS = ['ks', 'm', 'm2', 'kg', 'g', 'l', 'ml', 'bal', 'role', 'sada'];

const qty = z
  .string()
  .trim()
  .regex(/^\d*([.,]\d{1,3})?$/, 'Neplatné množství')
  .or(z.literal(''));

const money = z
  .string()
  .trim()
  .regex(/^\d*([.,]\d{1,2})?$/, 'Neplatná cena')
  .or(z.literal(''));

export const materialFormSchema = z.object({
  sku: z.string().trim().min(1, 'SKU je povinné').max(80),
  name: z.string().trim().min(1, 'Název je povinný').max(200),
  category: z.string().trim().max(100).or(z.literal('')),
  unit: z.string().trim().min(1, 'Jednotka je povinná').max(20),
  stockQty: qty,
  minQty: qty,
  pricePerUnit: money,
  currency: z.string().trim().length(3, '3 znaky (např. CZK)'),
  supplier: z.string().trim().max(200).or(z.literal('')),
  supplierUrl: z.string().trim().url('Neplatná URL').max(500).or(z.literal('')),
  location: z.string().trim().max(100).or(z.literal('')),
  notes: z.string().trim().max(5000).or(z.literal('')),
  barcode: z.string().trim().max(64).or(z.literal('')),
  locationId: z.string().or(z.literal('')),
});

export type MaterialFormValues = z.infer<typeof materialFormSchema>;

export const emptyMaterialForm: MaterialFormValues = {
  sku: '',
  name: '',
  category: '',
  unit: 'ks',
  stockQty: '0',
  minQty: '',
  pricePerUnit: '',
  currency: 'CZK',
  supplier: '',
  supplierUrl: '',
  location: '',
  notes: '',
  barcode: '',
  locationId: '',
};
